export interface ScriptValidationResult {
  isValid: boolean;
  error?: string;
}

const stripStringsAndComments = (code: string): string => {
  let result = '';
  let inSingle = false;
  let inDouble = false;
  let inTemplate = false;
  let inLineComment = false;
  let inBlockComment = false;
  let escaped = false;

  for (let i = 0; i < code.length; i++) {
    const current = code[i];
    const next = code[i + 1];

    if (inLineComment) {
      if (current === '\n') {
        inLineComment = false;
        result += '\n';
      }
      continue;
    }

    if (inBlockComment) {
      if (current === '*' && next === '/') {
        inBlockComment = false;
        i++;
      }
      continue;
    }

    if (inSingle) {
      if (!escaped && current === '\'') {
        inSingle = false;
      }
      escaped = !escaped && current === '\\';
      result += ' ';
      continue;
    }

    if (inDouble) {
      if (!escaped && current === '"') {
        inDouble = false;
      }
      escaped = !escaped && current === '\\';
      result += ' ';
      continue;
    }

    if (inTemplate) {
      if (!escaped && current === '`') {
        inTemplate = false;
      }
      escaped = !escaped && current === '\\';
      result += current === '\n' ? '\n' : ' ';
      continue;
    }

    escaped = false;

    if (current === '/' && next === '/') {
      inLineComment = true;
      i++;
      continue;
    }

    if (current === '/' && next === '*') {
      inBlockComment = true;
      i++;
      continue;
    }

    if (current === '\'') {
      inSingle = true;
      result += ' ';
      continue;
    }

    if (current === '"') {
      inDouble = true;
      result += ' ';
      continue;
    }

    if (current === '`') {
      inTemplate = true;
      result += ' ';
      continue;
    }

    result += current;
  }

  return result;
};

const findUnsupportedFeature = (code: string): string | null => {
  const sanitized = stripStringsAndComments(code);

  if (/\bimport\s*(?:\(|[\s{*])/m.test(sanitized)) {
    return 'Imports are not supported.';
  }

  if (/\brequire\s*\(/m.test(sanitized)) {
    return 'require() is not supported.';
  }

  if (/\basync\s+function\b/m.test(sanitized)) {
    return 'Async functions are not supported.';
  }

  if (/\basync\s*(?:\([^)]*\)|[A-Za-z_$][\w$]*)\s*=>/m.test(sanitized)) {
    return 'Async functions are not supported.';
  }

  if (/(^|[;{\s])async\s+[A-Za-z_$][\w$]*\s*\([^)]*\)\s*\{/m.test(sanitized)) {
    return 'Async functions are not supported.';
  }

  return null;
};

export const validateScriptSupport = (code: string): ScriptValidationResult => {
  const error = findUnsupportedFeature(code || '');
  if (error) {
    return { isValid: false, error };
  }

  return { isValid: true };
};
